import { render, staticRenderFns } from "./Business-table.vue?vue&type=template&id=3e460a9a"
import script from "./Business-table.vue?vue&type=script&lang=js"
export * from "./Business-table.vue?vue&type=script&lang=js"
import style0 from "./Business-table.vue?vue&type=style&index=0&id=3e460a9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports